import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Pagewrapper } from "../../components";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";

const Doutrinas = (props) => (
  <Pagewrapper {...props}>
    <Container>
      <Row>
        <Col>
          <h1 className="mt-5 text-center">Doutrinas</h1>
          <p className="text-center text-muted">Lista de doutrinas disponíveis</p>
          
          <div className="mt-4">
            <h3>Doutrinas Disponíveis:</h3>
            <div className="row">
              <div className="col-md-8">
                <ul className="list-group">
                  <li className="list-group-item">
			               <Link to="/doutrinas/68193ede61d233107a492529" className="text-decoration-none">
                      <strong>O Regime Tributário das Estatais na Concessão do Serviço Após o Novo Marco Legal do Saneamento</strong><br/>
                      <small className="text-muted">Luiz Alberto G. S. Rocha - Área: Administrativo</small>
                    </Link>
                  </li>
                  <li className="list-group-item">
                    <Link to="/doutrinas/68193f2461d233107a492c98" className="text-decoration-none">
                      <strong>A Relevância da Prevenção Acidentária e o Resumo dos Processos Judiciais Relacionados a Acidente de Trabalho</strong><br/>
                      <small className="text-muted">Fernando Rubin - Área: Trabalhista</small>
                    </Link>
                  </li>
                  <li className="list-group-item">
                    <Link to="/doutrinas/68193efa61d233107a4927ec" className="text-decoration-none">
                      <strong>O Dano Moral Decorrente das Relações Consumeristas</strong><br/>
                      <small className="text-muted">Izaul Lopes dos Santos - Área: Civil</small>
                    </Link>
                  </li>
                  <li className="list-group-item">
                    <Link to="/doutrinas/1" className="text-decoration-none">
                      <strong>Doutrina de Teste 1</strong><br/>
                      <small className="text-muted">Exemplo - Áreas: Civil, Penal</small>
                    </Link>
                  </li>
                  <li className="list-group-item">
                    <Link to="/doutrinas/2" className="text-decoration-none">
                      <strong>Doutrina de Teste 2</strong><br/>
                      <small className="text-muted">Exemplo - Área: Trabalhista</small>
                    </Link>
                  </li>
                  <li className="list-group-item">
                    <Link to="/doutrinas/3" className="text-decoration-none">
                      <strong>Doutrina de Teste 3</strong><br/>
                      <small className="text-muted">Exemplo - Área: Administrativo</small>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-4">
                <div className="alert alert-info">
                  <h5>Navegação:</h5>
                  <p>Clique em qualquer doutrina para ver seu conteúdo detalhado.</p>
                  <p>A URL seguirá o padrão: <code>/doutrinas/[ID]</code></p>
                  <hr/>
                  <p><strong>Destaque:</strong> A primeira doutrina contém o conteúdo real mockado do backend!</p>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </Pagewrapper>
);

export default Doutrinas;